import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { KeysTab } from '@/features/settings/keys-tab';
import { UsersTab } from '@/features/settings/users-tab';
import { WebhooksTab } from '@/features/settings/webhooks-tab';
import { meQuery } from '@/lib/queries';
import { ListSkeleton } from '@/components/ui/feedback';

const searchSchema = z.object({
  tab: z.enum(['keys', 'users', 'webhooks']).optional(),
});

export const Route = createFileRoute('/_app/settings')({
  // The shape this page takes, rather than a search box over a table for
  // every route: the screen must not rearrange itself once the data lands.
  pendingComponent: () => <ListSkeleton rows={5} columns={5} />,
  validateSearch: searchSchema,
  component: SettingsPage,
});

/** The Keys and Users segments live in the header bar, as in the portal. */
function SettingsPage() {
  const { tab } = Route.useSearch();
  const { data: me } = useQuery(meQuery());
  const role = me?.auth.user?.role;
  const isOwner = role === 'owner' || role === 'staff';

  if (tab === 'users') return <UsersTab isOwner={isOwner} />;
  if (tab === 'webhooks') return <WebhooksTab isOwner={isOwner} />;
  return <KeysTab />;
}
